import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import LazyLoad from 'react-lazyload';
import PropTypes from 'prop-types';
import IconEmpty from 'assets/images/icons/icon_empty.svg';

import styles from './styles.module.less';

const NoDesignsAvailable = ({ clearAll }) => (
  <div className={styles.container}>
    <LazyLoad once offset={100}>
      <img src={IconEmpty} width="124" height="127" alt="no cards" />
    </LazyLoad>
    <h3 className={styles.title}>
      Hm... we couldn&apos;t find any designs that match what you&apos;re searching for.
    </h3>
    <div className={styles.subTitle}>
      Try clearing your filters to find what you&apos;re looking for.
    </div>
    <ButtonV2 onClick={clearAll}>Clear all filters</ButtonV2>
  </div>
);

NoDesignsAvailable.propTypes = {
  clearAll: PropTypes.func.isRequired,
};

export default NoDesignsAvailable;
